export default class RecipeIntroAd {
    constructor($wrapper) {
        this.$trigger = $wrapper.querySelector('[data-move-leaderboard]');
        this.$targetAbove = $wrapper.querySelector('[data-target-leaderboard-above]');
        this.$targetBelow = $wrapper.querySelector('[data-target-leaderboard-below]');

        if (this.$trigger) {
            this.moveLeaderboard();
        }
    }

    moveLeaderboard() {
        // Fetch the position the user desired, which is "above" or "below"
        let $position = this.$trigger.dataset.moveLeaderboard;

        // Prepare the default elements
        let $target = this.$targetAbove;
        let $remove = this.$targetBelow;

        // Note that the scope is as follows:
        // - on desktop, always render above
        // - on mobile, follow the setting
        $position = (window.innerWidth < 768) ? $position : 'above';

        // Reassign if needed
        if ($position === 'below') {
            $target = this.$targetBelow;
            $remove = this.$targetAbove;
        }

        // Remove the unused one
        $remove.remove();

        // Move the leaderboard to the target
        $target.appendChild(this.$trigger);

        // Display
        this.$trigger.style.display = null;
    }
}